import { CSSProperties } from "react";
import { colors } from "../../../theme";

/**
 * Pill styles for base-ui Popover.Trigger elements.
 *
 * base-ui renders its own <button>, so wrapping a MUI <Button> inside it nests
 * two buttons - invalid HTML that React logs a hydration error for. These styles
 * let the trigger itself carry the pill look instead.
 */
export function pillTriggerStyle(
    variant: "primary" | "ghost",
    size: "medium" | "large" = "medium",
): CSSProperties {
    const padding = size === "large"
        ? "14px 38px"
        : variant === "primary" ? "10px 26px" : "10px 18px";

    return {
        font: "inherit",
        fontWeight: 700,
        fontSize: size === "large" ? 16 : 15,
        lineHeight: 1.2,
        padding,
        borderRadius: 500,
        border: "none",
        cursor: "pointer",
        whiteSpace: "nowrap",
        transition: "transform 120ms ease, background-color 120ms ease, color 120ms ease",
        backgroundColor: variant === "primary" ? colors.accent : "transparent",
        color: variant === "primary" ? "#04121C" : colors.textSecondary,
    };
}

export const popupStyle: CSSProperties = {
    backgroundColor: colors.elevated,
    borderRadius: 12,
    padding: "28px 26px",
    width: 340,
    border: `1px solid ${colors.line}`,
    boxShadow: "0 24px 60px rgba(0,0,0,0.7)",
    position: "relative",
};

export const positionerStyle: CSSProperties = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2000,
};

export const closeButtonStyle: CSSProperties = {
    position: "absolute",
    top: 10,
    right: 12,
    background: "none",
    border: "none",
    fontSize: 20,
    lineHeight: 1,
    fontWeight: 400,
    color: colors.textMuted,
    cursor: "pointer",
    borderRadius: 999,
    // base-ui autofocuses this on open; the UA's default ring is jarring against
    // the dark surface, so use a subtle accent ring instead of removing it.
    outlineColor: colors.accent,
    outlineOffset: 2,
};

export const backdropStyle: CSSProperties = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.65)",
    zIndex: 1999,
};
